/**
 * Created by glopez on 22/05/17.
 */

// Action types
const ActionTypes = {
        SET_MINIEPG_STATUS: 'SET_MINIEPG_STATUS'
    },

    // Status values
    Status = {
        COLLAPSED: 'collapsed',
        EXPANDED: 'expanded'
    };

/**
 * Creates and returns a set status action.
 *
 * @param {string} status - Status of the component.
 * @returns {Object} Set status action.
 */
function setStatus (status) {
    return {
        type: ActionTypes.SET_MINIEPG_STATUS,
        status
    };
}

export {
    ActionTypes,
    Status,
    setStatus
};


// WEBPACK FOOTER //
// ./src/js/store/actions/modules/miniepg.js